module.exports = __webpack_public_path__ + "img/GAME_NATIONWIDETOUR.2bafb993.png";